import * as actionTypes from "./actionTypes";

export const sendMerchantInterestEmail = data => {
  return {
    type: actionTypes.SEND_MERCHANT_INTEREST_EMAIL,
    data
  };
};

export const sendMerchantInterestEmailSuccess = data => {
  return {
    type: actionTypes.SEND_MERCHANT_INTEREST_EMAIL_SUCCESS,
    data
  };
};

export const sendMerchantInterestEmailFail = () => {
  return {
    type: actionTypes.SEND_MERCHANT_INTEREST_EMAIL_FAIL
  };
};
